// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__10_QM","right":"styles_right__77P6K"};